module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/common/en-US/btn_back.png";